<template>
  <div class="layer-selections-container">
    <b-card no-body>
      <b-card-header header-class="layer-selections-header" v-b-toggle.layer-selector role="tab">
        <span>Layers</span>
        <i
          :class="`fas ${collapseIcon}`"
          style="font-size: 20px; vertical-align: middle; float: right;"
        ></i>
      </b-card-header>
      <b-collapse id="layer-selector" v-model="visibleState" role="tabpanel">
        <component v-bind:is="selectedSelector"></component>
      </b-collapse>
    </b-card>
    <b-tabs justified end @input="selectTab" active-nav-item-class="tab-nav-active-text">
      <b-tab v-for="tab in tabs" :key="`${tab.key}-picker`" title-link-class="title-nav-link">
        <template v-slot:title>
          <i
            :class="`fas ${tab.icon}`"
            :title="tab.name"
            class="tab-nav-text"
          ></i>
        </template>
      </b-tab>
    </b-tabs>
  </div>
</template>

<script>
import BasemapsSelector from './layer-selectors/Basemaps';
import MosaicsSelector from './layer-selectors/Mosaics';

export default {
  components: {
    'mosaics-selector': MosaicsSelector,
    'basemaps-selector': BasemapsSelector,
  },
  data() {
    return {
      selectedSelector: '',
      collapseIcon: 'fa-angle-down',
      visibleState: true,
      tabs: [
        {
          name: 'Mosaics',
          icon: 'fa-th',
          key: 'mosaics',
        },
        {
          name: 'Basemaps',
          icon: 'fa-layer-group',
          key: 'basemaps',
        },
      ],
    };
  },
  methods: {
    selectTab(tabIndex) {
      const selectedTab = this.tabs[tabIndex];
      this.selectedSelector = `${selectedTab.key}-selector`;
      if (!this.visibleState) {
        this.visibleState = true;
      }
    },
  },
  watch: {
    visibleState(newVal) {
      if (newVal) {
        this.collapseIcon = 'fa-angle-down';
      } else {
        this.collapseIcon = 'fa-angle-up';
      }
    },
  },
};
</script>

<style>
.layer-selections-container {
  width: 240px;
  background-color: #fff !important;
  border-radius: 2px;
  box-shadow: 0 0 6px rgba(0, 0, 0, 0.74) !important;
}

.layer-selections-header {
  padding: 5px 8px 5px 6px;
  margin: 0;
  font-size: 16px;
  font-weight: bold;
  background-color: #1f1f1f !important;
  color: #fff !important;
}

.title-nav-link {
  color: #495057 !important;
}

.tab-nav-text {
  font-size: 1.2rem;
}

.tab-nav-active-text {
  color: #3995a3 !important;
  border: 0 !important;
}
</style>
